import { useLingui } from '@lingui/react/macro'
import { Link } from '@tanstack/react-router'
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from 'designSystem/components/Sidebar'
import { NavItemConfig } from 'features/navbar/navConfig'
import { SelectedTab } from 'features/navbar/types'
import { PermissionsGate } from 'features/permissions'
import { type MouseEvent, useCallback } from 'react'
import styled from 'styled-components'

const NavItemLabel = styled.span<{ $chatLayout: boolean }>`
  color: ${({ $chatLayout }) =>
    $chatLayout ? 'var(--foreground)' : 'inherit'};
`

export function EmbeddedSidebarHomeNavItem({
  chatLayout,
  config,
  isActive,
  onNavigate,
  orgID,
  siteID,
  tabKey,
}: {
  chatLayout: boolean
  config: NavItemConfig
  isActive: boolean
  onNavigate: (
    event: MouseEvent<HTMLAnchorElement>,
    tabKey: SelectedTab,
    label: string
  ) => void
  orgID: string | undefined
  siteID: string | undefined
  tabKey: SelectedTab
}) {
  const { i18n } = useLingui()
  const label = i18n._(config.label)
  const Icon = config.icon
  const params = config.params?.(siteID ?? '', orgID)
  const search = config.search?.(siteID ?? '', orgID)
  const handleClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      onNavigate(event, tabKey, label)
    },
    [label, onNavigate, tabKey]
  )

  const menuItem = (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        isActive={isActive}
        size={chatLayout ? 'sm' : 'default'}
        variant='embedded'
        tooltip={label}>
        <Link
          to={config.to}
          params={params}
          search={search}
          onClick={handleClick}>
          <Icon />
          <NavItemLabel $chatLayout={chatLayout}>{label}</NavItemLabel>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )

  if (config.permissions) {
    return (
      <PermissionsGate requires={config.permissions} except={config.except}>
        {menuItem}
      </PermissionsGate>
    )
  }

  return menuItem
}
